import { useContext } from "react";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import DeleteChartModal from "./DeleteChartModal";
import { deleteChart } from "../../services/chartService";
import role from "../../utils/role";
import AuthContext from "../Auth/Middleware/AuthContext";
import { milestoneConstants, qcStatusConstants } from "../../utils/constants";

function NewChart({ data, onReRenderChart }) {
  onReRenderChart(false);
  const auth = useContext(AuthContext);
  const navigate = useNavigate();

  const priortyIds = {
    1: "Critical",
    2: "High",
    3: "Medium",
    4: "Low",
  };

  const getPriority = () => {
    if (auth.role === role.Auditor) {
      return priortyIds[data.auditor_PriorityId];
    } else if (auth.role === role.Coder) {
      return priortyIds[data.coder_PriorityId];
    }
    return data.Priority;
  };

  const onDeleteHandler = async () => {
    try {
      const payload = {
        chartId: [data?.Id],
        worklistId: data?.WorklistId,
      };
      if (
        data?.MilestoneId ===
          milestoneConstants.AUDIT_IN_PROGRESS_MILESTONE_ID ||
        data?.MilestoneId === milestoneConstants.CODING_IN_PROGRESS_MILESTONE_ID
      ) {
        return window.toastr.error(
          "This chart cannot be deleted because it is currently in progress ",
        );
      }
      const res = await deleteChart(payload);
      if (res.success) {
        window.toastr.success("Successfully deleted chart");
        navigate("/");
      }
    } catch (error) {
      window.toastr.error("Something failed");
    }
  };
  const [showModalBox, setShowModalBox] = useState(false);

  const closeModal = () => {
    setShowModalBox(false);
  };

  const qcStatusText = () => {
    if (data?.qc_status_id === qcStatusConstants.QC_FAIL_ID) {
      return { color: "#f1416c" };
    }
    if (data?.qc_status_id === qcStatusConstants.QC_PASS_ID) {
      return { color: "#50cd89" };
    }
    if (data?.qc_status_id === qcStatusConstants.QC_IMPLEMENTED_ID) {
      return { color: "#ffc60b" };
    }
    if (data?.qc_status_id === qcStatusConstants.QC_REJECTED_ID) {
      return { color: "#f1416c" };
    }
  };

  return (
    <div className="card mb-5 mb-xl-10 chart_card">
      <div className="card-body pt-9 pb-0">
        <div className="d-flex flex-wrap flex-sm-nowrap mb-3">
          <div className="flex-grow-1">
            <div className="justify-content-between align-items-start flex-wrap mb-2">
              <div className="d-flex flex-column">
                <div className="d-flex justify-content-between align-items-start flex-wrap mb-0">
                  <h1 className="fs-2 fw-bold me-1">Chart: {data?.ChartNo}</h1>
                  <p className="fs-7 text-muted">
                    Priority
                    <span className="btn btn-sm btn-light-danger fw-bold ms-2 fs-8 py-1 px-3">
                      {" "}
                      {getPriority()}
                    </span>{" "}
                  </p>
                </div>
                <div className="d-flex flex-wrap fw-semibold fs-6 mb-4 pe-2">
                  <Link className="d-flex align-items-center text-gray-400 text-hover-primary me-5 mb-2">
                    <span className="svg-icon svg-icon-4 me-1">
                      <svg
                        width={18}
                        height={18}
                        viewBox="0 0 18 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          opacity="0.3"
                          d="M16.5 9C16.5 13.125 13.125 16.5 9 16.5C4.875 16.5 1.5 13.125 1.5 9C1.5 4.875 4.875 1.5 9 1.5C13.125 1.5 16.5 4.875 16.5 9Z"
                          fill="currentColor"
                        />
                        <path
                          d="M9 16.5C10.95 16.5 12.75 15.75 14.025 14.55C13.425 12.675 11.4 11.25 9 11.25C6.6 11.25 4.57499 12.675 3.97499 14.55C5.24999 15.75 7.05 16.5 9 16.5Z"
                          fill="currentColor"
                        />
                        <rect
                          x={7}
                          y={6}
                          width={4}
                          height={4}
                          rx={2}
                          fill="currentColor"
                        />
                      </svg>
                    </span>
                    Client:{data?.ClientName}
                    <strong className="ms-2"></strong>
                  </Link>
                  <Link className="d-flex align-items-center text-gray-400 text-hover-primary me-5 mb-2">
                    <span className="svg-icon svg-icon-muted svg-icon-1hx me-1">
                      <svg
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13 5.91517C15.8 6.41517 18 8.81519 18 11.8152C18 12.5152 17.9 13.2152 17.6 13.9152L20.1 15.3152C20.6 15.6152 21.4 15.4152 21.6 14.8152C21.9 13.9152 22.1 12.9152 22.1 11.8152C22.1 7.01519 18.8 3.11521 14.3 2.01521C13.7 1.91521 13.1 2.31521 13.1 3.01521V5.91517H13Z"
                          fill="currentColor"
                        />
                        <path
                          opacity="0.3"
                          d="M19.1 17.0152C19.7 17.3152 19.8 18.1152 19.3 18.5152C17.5 20.5152 14.9 21.7152 12 21.7152C9.1 21.7152 6.50001 20.5152 4.70001 18.5152C4.30001 18.0152 4.39999 17.3152 4.89999 17.0152L7.39999 15.6152C8.49999 16.9152 10.2 17.8152 12 17.8152C13.8 17.8152 15.5 17.0152 16.6 15.6152L19.1 17.0152ZM6.39999 13.9151C6.19999 13.2151 6 12.5152 6 11.8152C6 8.81517 8.2 6.41515 11 5.91515V3.01519C11 2.41519 10.4 1.91519 9.79999 2.01519C5.29999 3.01519 2 7.01517 2 11.8152C2 12.8152 2.2 13.8152 2.5 14.8152C2.7 15.4152 3.4 15.7152 4 15.3152L6.39999 13.9151Z"
                          fill="currentColor"
                        />
                      </svg>
                    </span>
                    Process: <strong className="ms-2">{data?.Process}</strong>
                  </Link>
                  <Link className="d-flex align-items-center text-gray-400 text-hover-primary me-5 mb-2">
                    <span className="svg-icon svg-icon-4 me-1">
                      <svg
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          opacity="0.3"
                          d="M21 19H3C2.4 19 2 18.6 2 18V6C2 5.4 2.4 5 3 5H21C21.6 5 22 5.4 22 6V18C22 18.6 21.6 19 21 19Z"
                          fill="currentColor"
                        />
                        <path
                          d="M21 5H2.99999C2.69999 5 2.49999 5.10005 2.29999 5.30005L11.2 13.3C11.7 13.7 12.4 13.7 12.8 13.3L21.7 5.30005C21.5 5.10005 21.3 5 21 5Z"
                          fill="currentColor"
                        />
                      </svg>
                    </span>
                    Primary Specialty:{" "}
                    <strong className="ms-2">{data?.Specialty}</strong>
                  </Link>
                  <Link className="d-flex align-items-center text-gray-400 text-hover-primary mb-2 me-5">
                    <span className="svg-icon svg-icon-4 me-1">
                      <svg
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          opacity="0.3"
                          d="M18.0624 15.3453L13.1624 20.7453C12.5624 21.4453 11.5624 21.4453 10.9624 20.7453L6.06242 15.3453C4.56242 13.6453 3.76242 11.4453 4.06242 8.94534C4.56242 5.34534 7.46242 2.44534 11.0624 2.04534C15.8624 1.54534 19.9624 5.24534 19.9624 9.94534C20.0624 12.0453 19.2624 13.9453 18.0624 15.3453Z"
                          fill="currentColor"
                        />
                        <path
                          d="M12.0624 13.0453C13.7193 13.0453 15.0624 11.7022 15.0624 10.0453C15.0624 8.38849 13.7193 7.04535 12.0624 7.04535C10.4056 7.04535 9.06241 8.38849 9.06241 10.0453C9.06241 11.7022 10.4056 13.0453 12.0624 13.0453Z"
                          fill="currentColor"
                        />
                      </svg>
                    </span>
                    Location: <strong className="ms-2">{data?.Location}</strong>
                  </Link>
                  <Link className="d-flex align-items-center text-gray-400 text-hover-primary me-5 mb-2">
                    <span className="svg-icon svg-icon-4 me-1">
                      <svg
                        width={18}
                        height={18}
                        viewBox="0 0 18 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          opacity="0.3"
                          d="M16.5 9C16.5 13.125 13.125 16.5 9 16.5C4.875 16.5 1.5 13.125 1.5 9C1.5 4.875 4.875 1.5 9 1.5C13.125 1.5 16.5 4.875 16.5 9Z"
                          fill="currentColor"
                        />
                        <path
                          d="M9 16.5C10.95 16.5 12.75 15.75 14.025 14.55C13.425 12.675 11.4 11.25 9 11.25C6.6 11.25 4.57499 12.675 3.97499 14.55C5.24999 15.75 7.05 16.5 9 16.5Z"
                          fill="currentColor"
                        />
                        <rect
                          x={7}
                          y={6}
                          width={4}
                          height={4}
                          rx={2}
                          fill="currentColor"
                        />
                      </svg>
                    </span>
                    Allocated User:{" "}
                    <strong className="ms-2">{`${data?.UserFirstName} ${data?.UserLastName}`}</strong>
                  </Link>
                  <Link className="d-flex align-items-center text-gray-400 text-hover-primary me-5 mb-2">
                    <span className="svg-icon svg-icon-4 me-1">
                      <svg
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          opacity="0.3"
                          d="M21 19H3C2.4 19 2 18.6 2 18V6C2 5.4 2.4 5 3 5H21C21.6 5 22 5.4 22 6V18C22 18.6 21.6 19 21 19Z"
                          fill="currentColor"
                        />
                        <path
                          d="M21 5H2.99999C2.69999 5 2.49999 5.10005 2.29999 5.30005L11.2 13.3C11.7 13.7 12.4 13.7 12.8 13.3L21.7 5.30005C21.5 5.10005 21.3 5 21 5Z"
                          fill="currentColor"
                        />
                      </svg>
                    </span>
                    Sub Specialty:{" "}
                    <strong className="ms-2">{data?.SubSpecialty}</strong>
                  </Link>
                  <Link className="d-flex align-items-center text-gray-400 text-hover-primary mb-2">
                    <span className="svg-icon svg-icon-4 me-1">
                      <svg
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13 5.91517C15.8 6.41517 18 8.81519 18 11.8152C18 12.5152 17.9 13.2152 17.6 13.9152L20.1 15.3152C20.6 15.6152 21.4 15.4152 21.6 14.8152C21.9 13.9152 22.1 12.9152 22.1 11.8152C22.1 7.01519 18.8 3.11521 14.3 2.01521C13.7 1.91521 13.1 2.31521 13.1 3.01521V5.91517H13Z"
                          fill="currentColor"
                        />
                        <path
                          opacity="0.3"
                          d="M19.1 17.0152C19.7 17.3152 19.8 18.1152 19.3 18.5152C17.5 20.5152 14.9 21.7152 12 21.7152C9.1 21.7152 6.50001 20.5152 4.70001 18.5152C4.30001 18.0152 4.39999 17.3152 4.89999 17.0152L7.39999 15.6152C8.49999 16.9152 10.2 17.8152 12 17.8152C13.8 17.8152 15.5 17.0152 16.6 15.6152L19.1 17.0152ZM6.39999 13.9151C6.19999 13.2151 6 12.5152 6 11.8152C6 8.81517 8.2 6.41515 11 5.91515V3.01519C11 2.41519 10.4 1.91519 9.79999 2.01519C5.29999 3.01519 2 7.01517 2 11.8152C2 12.8152 2.2 13.8152 2.5 14.8152C2.7 15.4152 3.4 15.7152 4 15.3152L6.39999 13.9151Z"
                          fill="currentColor"
                        />
                      </svg>
                    </span>
                    Qc status:{" "}
                    <strong className="ms-2" style={qcStatusText()}>{`${
                      data?.qc_status ?? ""
                    }`}</strong>
                  </Link>
                </div>
              </div>
            </div>
            <div className="d-flex flex-wrap flex-stack">
              <div className="d-flex flex-column flex-grow-1 pe-8">
                <div className="d-flex flex-wrap">
                  <div className="border border-gray-300 border-dashed rounded min-w-120px py-3 px-4 me-3 mb-3">
                    <div className="d-flex align-items-center">
                      <div className="fs-5 fw-bold">{data?.Worklist}</div>
                    </div>
                    <div className="fw-semibold fs-6 text-gray-400">
                      Worklist #
                    </div>
                  </div>
                  <div className="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-3 mb-3">
                    <div className="d-flex align-items-center">
                      <div
                        className="fs-5 fw-bold"
                        data-kt-countup="false"
                        data-kt-countup-value={75}
                      >
                        {data?.Milestone}
                      </div>
                    </div>
                    <div className="fw-semibold fs-6 text-gray-400">
                      Milestone
                    </div>
                  </div>
                  <div className="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-3 mb-3">
                    <div className="d-flex align-items-center">
                      <div
                        className="fs-5 fw-bold"
                        data-kt-countup="false"
                        data-kt-countup-value=""
                        data-kt-countup-suffix=""
                      >
                        {data?.Status}
                      </div>
                    </div>
                    <div className="fw-semibold fs-6 text-gray-400">Status</div>
                  </div>
                  <div className="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-3 mb-3">
                    <div className="d-flex align-items-center">
                      <div
                        className="fs-5 fw-bold"
                        data-kt-countup="false"
                        data-kt-countup-value=""
                        data-kt-countup-suffix=""
                      >
                        {data?.auditedWeek}
                      </div>
                    </div>
                    <div className="fw-semibold fs-6 text-gray-400">
                      Audited week
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row py-0">
              <div className="col-xxl-3 col-xl-6 col-lg-3 col-md-3 col-6">
                <div className="py-3 mb-3">
                  <div className="ms-5">
                    <p className="fs-5 fw-bold mb-0">{data?.SNo ?? 'NA'}</p>
                    <div className="text-muted fs-7">S. No.</div>
                  </div>
                </div>
              </div>
              <div className="col-xxl-3 col-xl-6 col-lg-3 col-md-3 col-6">
                <div className="py-3 mb-3">
                  <div className="ms-5">
                    <p className="fs-5 fw-bold mb-0">{data?.DateOfService ?? 'NA'}</p>
                    <div className="text-muted fs-7">Date of service</div>
                  </div>
                </div>
              </div>
              <div className="col-xxl-3 col-xl-6 col-lg-3 col-md-3 col-6">
                <div className="py-3 mb-3">
                  <div className="ms-5">
                    <p className="fs-5 fw-bold mb-0">{data?.ReceivedDate ?? 'NA'}</p>
                    <div className="text-muted fs-7">Received date</div>
                  </div>
                </div>
              </div>
              <div className="col-xxl-3 col-xl-6 col-lg-3 col-md-3 col-6">
                <div className="py-3 mb-3">
                  <div className="ms-5">
                    <p className="fs-5 fw-bold mb-0">
                      {data?.DateOfCompletion ?? 'NA'}
                    </p>
                    <div className="text-muted fs-7">Completion date</div>
                  </div>
                </div>
              </div>
              <div className="col-xxl-3 col-xl-6 col-lg-3 col-md-3 col-6">
                <div className="py-3 mb-3">
                  <div className="ms-5">
                    <p className="fs-5 fw-bold mb-0">
                      {data?.DateOfCoderAllocation ?? 'NA'}
                    </p>
                    <div className="text-muted fs-7">Date of Coder Allocation</div>
                  </div>
                </div>
              </div>
              <div className="col-xxl-3 col-xl-6 col-lg-3 col-md-3 col-6">
                <div className="py-3 mb-3">
                  <div className="ms-5">
                    <p className="fs-5 fw-bold mb-0">
                      {data?.DateOfAuditorAllocation ?? 'NA'}
                    </p>
                    <div className="text-muted fs-7">Date of Auditor Allocation</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row py-0 ">
              <div className="col">
                <div className="py-3 mb-3">
                  {(auth?.role === role?.TeamLead ||
                    auth?.role === role?.Manager) && (
                    <button
                      type="button"
                      className="btn btn-danger ms-4 btn-filter"
                      onClick={() => setShowModalBox(true)}
                    >
                      <i className="fas fa-trash"></i>
                      Delete Chart
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <DeleteChartModal
        onDeleteHandler={onDeleteHandler}
        showModalBox={showModalBox}
        closeModal={closeModal}
      />
    </div>
  );
}
export default NewChart;
